import { useEffect } from 'react';

export const useAppTitle = (title) => {

    useEffect(() => {

        document.title = title;

    }, [title]);

};
